import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=9ebbc1ca&scoped=true&"
import script from "./Challenges.vue?vue&type=script&lang=ts&"
export * from "./Challenges.vue?vue&type=script&lang=ts&"
import style0 from "./Challenges.vue?vue&type=style&index=0&id=9ebbc1ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebbc1ca",
  null
  
)

export default component.exports